<template>
  <b-navbar :fixed-bottom="true">
    <template slot="brand">
      <b-navbar-item>&copy; 2018- 2020 Infodemics - An Ingenia Initiative - RC1551305</b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item>
        Powered By
        <img src="../../assets/ebidhaa.png" />
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: "Footer"
};
</script>